import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Download } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUS_STYLES = {
  Received: 'bg-gray-100 text-gray-700',
  Approved: 'bg-green-100 text-green-800',
  Denied: 'bg-red-100 text-red-800',
};

const Field = ({ label, value }) => (
  <div>
    <p className="text-xs uppercase tracking-wide text-gray-500">{label}</p>
    <p className="text-gray-900 break-words">{value || '—'}</p>
  </div>
);

export const SlidingFeeCard = ({ app, onStatusChange }) => {
  const [open, setOpen] = useState(false);
  const id = app.confirmationId;
  const status = app.status || 'Received';
  const files = (app.files || []).filter((f) => !f.is_deleted);
  const submitted = app.submittedAt ? new Date(app.submittedAt).toLocaleDateString() : '—';

  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-100" data-testid={`sfdp-card-${id}`}>
      <button onClick={() => setOpen(!open)} data-testid={`sfdp-toggle-${id}`}
        className="w-full flex items-center justify-between gap-4 p-5 text-left">
        <div className="min-w-0">
          <p className="font-semibold text-gray-900 truncate">{app.fullName}</p>
          <p className="text-sm text-gray-600 truncate">{id} · {app.location} · Submitted {submitted}</p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <span data-testid={`sfdp-status-badge-${id}`} className={`text-xs font-semibold px-3 py-1 rounded-full ${STATUS_STYLES[status]}`}>{status}</span>
          {open ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </div>
      </button>

      {open && (
        <div className="border-t border-gray-100 p-5 space-y-5">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <Field label="Phone" value={app.phone} />
            <Field label="Email" value={app.email} />
            <Field label="Date of Birth" value={app.dob} />
            <Field label="Clinic Location" value={app.location} />
            <Field label="Status Updated By" value={app.status_updated_by} />
          </div>
          <div>
            <p className="text-xs uppercase tracking-wide text-gray-500 mb-2">Documents</p>
            {files.length === 0 ? (
              <p className="text-sm text-gray-600">No files saved on the website for this application. Check the sfapplications@cmcwv.com inbox.</p>
            ) : (
              <div className="flex flex-wrap gap-3">
                {files.map((f, i) => (
                  <a key={i} href={`${API}/sliding-fee/applications/${id}/file/${i}`} data-testid={`sfdp-download-${id}-${i}`}
                    className="inline-flex items-center gap-2 text-sm font-semibold text-blue-700 bg-blue-50 px-4 py-2 rounded-lg hover:bg-blue-100 transition-colors">
                    <Download size={16} /> {f.label}: {f.filename}
                  </a>
                ))}
              </div>
            )}
          </div>
          <div className="flex flex-wrap gap-2">
            {['Received', 'Approved', 'Denied'].map((s) => (
              <button key={s} onClick={() => onStatusChange(id, s)} disabled={s === status}
                data-testid={`sfdp-set-status-${s.toLowerCase()}-${id}`}
                className="text-sm font-semibold px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors disabled:bg-gray-900 disabled:text-white disabled:border-gray-900">
                {s === 'Received' ? 'Mark Received' : s === 'Approved' ? 'Approve' : 'Deny'}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
